import React, { useState } from 'react';
import { changePassword } from '../auth/cognito';
import '../pages/Login.css';

export default function ChangePasswordForm() {
  const [current,  setCurrent]  = useState('');
  const [next,     setNext]     = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [error,    setError]    = useState(null);
  const [success,  setSuccess]  = useState(false);
  const [busy,     setBusy]     = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError(null);
    setSuccess(false);
    if (next !== confirm) {
      setError('New passwords do not match.');
      return;
    }
    setBusy(true);
    try {
      await changePassword(current, next);
      setSuccess(true);
      setCurrent('');
      setNext('');
      setConfirm('');
    } catch (err) {
      setError(err.message || 'Password change failed.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="portal-panel" style={{ maxWidth: 480 }}>
      <div className="portal-panel-header">
        <span className="portal-panel-title">Change Password</span>
      </div>

      <form onSubmit={onSubmit} className="login-form" style={{ padding: '20px 24px 24px' }}>
        <label className="login-field">
          <span>Current password</span>
          <input
            type="password"
            autoComplete="current-password"
            required
            value={current}
            onChange={(e) => setCurrent(e.target.value)}
          />
        </label>

        <label className="login-field">
          <span>New password</span>
          <input
            type="password"
            autoComplete="new-password"
            required
            minLength={10}
            value={next}
            onChange={(e) => setNext(e.target.value)}
          />
          <span className="login-hint">Min. 10 characters, upper &amp; lowercase and a number.</span>
        </label>

        <label className="login-field">
          <span>Confirm new password</span>
          <input
            type="password"
            autoComplete="new-password"
            required
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
        </label>

        {error   && <p className="login-error">{error}</p>}
        {success && <p className="login-success">Password updated successfully.</p>}

        <button type="submit" className="btn btn-primary" disabled={busy} style={{ marginTop: 4 }}>
          {busy ? 'Saving…' : 'Change Password'}
        </button>
      </form>
    </div>
  );
}
